import {
  Checkbox,
  ListItem,
  ListItemButton,
  ListItemText,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import InputControl from "../../../shared/components/InputControl";

export const PlReportFilterSection = ({
  filter,
  storeList,
  locationList,
  financialYearList,
  accountMonthList,
  handleChangeFilter,
  hideMonthQuarters = false,
  validator = null,
}) => {
  const renderTags = () => <></>;
  const getOptionLabel = (option) => option.label;
  const isOptionEqualToValue = (option, value) => option.value === value.value;

  const isFinancialYearMultiple = Array.isArray(filter.values.financialYear);

  const storeOrStateValidation =
    storeList && locationList ? "storeOrState" : "required";

  const helperText = validator
    ? {
        store: validator.current.message(
          "Store",
          storeOrStateValidation === "required"
            ? filter.values.store
            : {
                store: filter.values.store,
                state: filter.values.state,
              },
          storeOrStateValidation
        ),
        state: validator.current.message(
          "State",
          { store: filter.values.store, state: filter.values.state },
          storeOrStateValidation
        ),
        financialYear: validator.current.message(
          "Financial year",
          filter.values.financialYear,
          "required"
        ),
        month: validator.current.message(
          "Month",
          filter.values.month,
          "required"
        ),
      }
    : {};

  return (
    <React.Fragment>
      {locationList && (
        <InputControl
          type="dropdown"
          name="state"
          label="State"
          multiple={true}
          disableCloseOnSelect
          disableClearable={true}
          getOptionLabel={getOptionLabel}
          isOptionEqualToValue={isOptionEqualToValue}
          options={filter.options.states}
          value={filter.values.state}
          onChange={(_, value) => handleChangeFilter({ name: "state", value })}
          renderTags={renderTags}
          renderInput={(params) => (
            <TextField
              {...params}
              label="State"
              placeholder="State"
              error={Boolean(helperText?.state)}
              helperText={helperText?.state}
            />
          )}
          groupBy={() => "All"}
          renderGroup={(params) => {
            const { values, options } = filter;

            const isAllChecked = values.state.length === options.states.length;

            const handleHeaderClick = () => {
              handleChangeFilter({
                event: null,
                name: "state",
                value: isAllChecked ? [] : options.states,
              });
            };

            return (
              <React.Fragment key={params.group}>
                {params.key === 0 && (
                  <ListItemButton
                    disableGutters
                    onClick={handleHeaderClick}
                    selected={isAllChecked}
                  >
                    <Checkbox size="small" checked={isAllChecked} />
                    <Typography>All</Typography>
                  </ListItemButton>
                )}
                <ListItemText>{params.children}</ListItemText>
              </React.Fragment>
            );
          }}
          renderOption={(props, option, { selected }) => (
            <ListItem
              {...props}
              key={option.value}
              disableGutters
              disablePadding
            >
              <Checkbox
                style={{ marginRight: 8 }}
                checked={selected}
                size="small"
              />
              {option.label}
            </ListItem>
          )}
          sx={{ maxWidth: "fit-content", minWidth: 200 }}
        />
      )}
      {storeList && (
        <InputControl
          type="dropdown"
          name="store"
          label="Store"
          multiple={true}
          disableCloseOnSelect
          disableClearable={true}
          getOptionLabel={getOptionLabel}
          isOptionEqualToValue={isOptionEqualToValue}
          options={filter.options.stores}
          value={filter.values.store}
          onChange={(_, value) => handleChangeFilter({ name: "store", value })}
          renderTags={renderTags}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Store"
              placeholder="Store"
              error={Boolean(helperText?.store)}
              helperText={
                storeOrStateValidation === "required" ? helperText?.store : ""
              }
            />
          )}
          groupBy={(option) => option.franchisee_name}
          renderGroup={(params) => {
            const { values, options } = filter;

            const isAllChecked = values.store.length === options.stores.length;

            const fullOptions = options.stores.filter(
              (store) => store.franchisee_name === params.group
            );

            const selectedOptions = values.store.filter(
              (store) => store.franchisee_name === params.group
            );

            const isChecked = fullOptions.length === selectedOptions.length;

            const handleHeaderClick = ({ item }) => {
              if (item === "all") {
                handleChangeFilter({
                  event: null,
                  name: "store",
                  value: isAllChecked ? [] : options.stores,
                });
              } else {
                handleChangeFilter({
                  event: null,
                  name: "store",
                  value: isChecked
                    ? values.store.filter(
                        (store) =>
                          !selectedOptions.find(
                            (opt) =>
                              opt.franchisee_name === store.franchisee_name
                          )
                      )
                    : values.store.concat(
                        fullOptions.filter(
                          (option) =>
                            !values.store.find(
                              (selectedStore) =>
                                selectedStore.value === option.value
                            )
                        )
                      ),
                });
              }
            };

            return (
              <React.Fragment key={params.group}>
                {params.key === 0 && (
                  <ListItemButton
                    disableGutters
                    onClick={() => handleHeaderClick({ item: "all" })}
                    selected={isAllChecked}
                  >
                    <Checkbox size="small" checked={isAllChecked} />
                    <Typography>All</Typography>
                  </ListItemButton>
                )}
                {params.group && (
                  <ListItemButton
                    disableGutters
                    onClick={() => handleHeaderClick({ item: params.group })}
                    selected={isChecked}
                  >
                    <Checkbox size="small" checked={isChecked} />
                    <Typography fontWeight={500}>{params.group}</Typography>
                  </ListItemButton>
                )}
                <ListItemText>{params.children}</ListItemText>
              </React.Fragment>
            );
          }}
          renderOption={(props, option, { selected }) => (
            <ListItem
              {...props}
              key={option.value}
              disableGutters
              disablePadding
            >
              <Checkbox
                style={{ marginRight: 8 }}
                checked={selected}
                size="small"
              />
              {option.label}
            </ListItem>
          )}
          sx={{ maxWidth: "fit-content", minWidth: 270 }}
        />
      )}
      {accountMonthList && (
        <InputControl
          type="dropdown"
          name="month"
          label="Month"
          multiple={true}
          disableCloseOnSelect
          disableClearable={true}
          getOptionLabel={getOptionLabel}
          isOptionEqualToValue={isOptionEqualToValue}
          options={filter.options.accountMonths}
          value={filter.values.month}
          onChange={(_, value) => handleChangeFilter({ name: "month", value })}
          renderTags={renderTags}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Month"
              placeholder="Month"
              error={Boolean(helperText?.month)}
              helperText={helperText?.month}
            />
          )}
          renderOption={(props, option, { selected }) => {
            const selectedMonths = filter.values.month;

            const isQuarterSelected = selectedMonths.find(
              (month) => month.value === option?.quarter
            );

            const isYearlySelected = selectedMonths.find(
              (month) => month.value === "Yearly"
            );

            return (
              <ListItemButton
                {...props}
                key={option.value}
                disableGutters
                disabled={
                  isYearlySelected
                    ? option.value === "Yearly"
                      ? Boolean(!isYearlySelected)
                      : Boolean(isYearlySelected)
                    : Boolean(isQuarterSelected)
                }
              >
                <Checkbox
                  style={{ marginRight: 8 }}
                  checked={selected}
                  size="small"
                />
                {option.label}
              </ListItemButton>
            );
          }}
          sx={{ maxWidth: "fit-content", minWidth: 230 }}
        />
      )}
      {financialYearList && (
        <InputControl
          type="dropdown"
          name="financialYear"
          label="Financial Year"
          multiple={isFinancialYearMultiple}
          disableCloseOnSelect
          disableClearable={isFinancialYearMultiple}
          getOptionLabel={getOptionLabel}
          isOptionEqualToValue={isOptionEqualToValue}
          options={filter.options.financialYears}
          value={filter.values.financialYear}
          onChange={(_, value) =>
            handleChangeFilter({ name: "financialYear", value })
          }
          groupBy={isFinancialYearMultiple ? () => "All" : undefined}
          renderGroup={
            isFinancialYearMultiple
              ? (params) => {
                  const { values, options } = filter;
                  const isChecked =
                    values.financialYear.length ===
                    options.financialYears.length; //isAllChildChecked({ params });

                  const handleHeaderClick = () => {
                    handleChangeFilter({
                      event: null,
                      name: "financialYear",
                      value: isChecked ? [] : options.financialYears,
                    });
                  };
                  return (
                    <React.Fragment key={params.group}>
                      <ListItemButton
                        onClick={handleHeaderClick}
                        sx={{
                          flexDirection: "row",
                          alignItems: "center",
                          ":hover": {
                            cursor: "pointer",
                            backgroundColor: "rgba(0,0,0,0.04)",
                          },
                        }}
                      >
                        <Checkbox size="small" checked={isChecked} />
                        <Typography>{params.group}</Typography>
                      </ListItemButton>
                      <ListItemText>{params.children}</ListItemText>
                    </React.Fragment>
                  );
                }
              : undefined
          }
          renderTags={renderTags}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Financial Year"
              placeholder="Financial year"
              error={Boolean(helperText?.financialYear)}
              helperText={helperText?.financialYear}
            />
          )}
          renderOption={
            isFinancialYearMultiple
              ? (props, option, { selected }) => (
                  <ListItem
                    {...props}
                    key={option.value}
                    disableGutters
                    disablePadding
                  >
                    <Checkbox
                      style={{ marginRight: 8 }}
                      checked={selected}
                      size="small"
                    />
                    {option.label}
                  </ListItem>
                )
              : undefined
          }
          sx={{ maxWidth: "fit-content", minWidth: 170 }}
        />
      )}
    </React.Fragment>
  );
};
